import React from "react";
import { useTranslation } from "react-i18next";

import Classes from "../classes/testimonals.module.css";
import TestimonalCard from "./TestimonalCard";
import { testimonalData } from "../data/testimonalData";

const Testimonials = () => {
  const { t, i18n } = useTranslation();
  const isTelugu = i18n.resolvedLanguage === "te";
  return (
    <section id="testimonials" className={Classes.testimonials}>
      <h1>{t("home.happyCustomers")}</h1>

      <div className={Classes.boxContainer}>
        {testimonalData.map((testimonal) => {
          const { content, contentTe, author } = testimonal;
          return (
            <TestimonalCard
              key={author}
              content={isTelugu ? contentTe : content}
              author={author}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Testimonials;
